import { Role } from '@/models/Roles';

export interface UserInternal {
  email: string;
  uuid: string;
}

export interface User {
  uuid: string;
  email: string;
  name: string;
  language: string;
  role?: Role;
  profilePic?: string;
}

export const EMPTY_USER: User = {
  uuid: '',
  email: '',
  name: '',
  language: 'en',
  role: Role.USER,
};
